import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { getRichTextFieldContent } from './TicketHandler';
import { AutoPassSystemFieldInSchema } from '@/common/constant/SystemField';
import { isShowFieldEventTypeChatThread } from './KnowledgeTicketHandler';

export const isInputAllFieldRequired = (fieldListData, getValuesCreateQaTicket, fileUploadList, fileUpdatedList = [], aiAutoSelectedData) => {
    let listFieldRequired = fieldListData?.filter(field => field.structure.required && field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW && !AutoPassSystemFieldInSchema.includes(field.sysField));
    // filter tag field not show
    listFieldRequired = listFieldRequired.filter(field => {
        if (field.sysField !== Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER) return true;
        return !!(isShowFieldEventTypeChatThread(aiAutoSelectedData));
    })

    if (!Utils.isEmptyArray(listFieldRequired)) {
        let isInputFieldRequired = true;

        for (let field of listFieldRequired) {
            let fieldValue = getValuesCreateQaTicket(field.id);
            if (field.type === Constant.FORM_TYPE.FIELD_RICHTEXT) {
                if(!fieldValue) {
                    return false;
                }
                let textInput = getRichTextFieldContent(fieldValue);
                
                if (!textInput || textInput === '""') {
                    return false;
                }
            } else {
                if (field.sysField === 'attachments') {
                    if (!Utils.isEmptyArray(fileUploadList)) {
                        if (!Utils.isEmptyArray(fileUpdatedList)) {
                            let fileActualUpload = [];
                            fileUploadList.forEach(file => {
                                if (file.fileUrl) {
                                    let isFileIsDelete = fileUpdatedList.find(fileUpdata => fileUpdata?.fileUrl === file.fileUrl && fileUpdata?.isDelete);
                                    if (!isFileIsDelete) {
                                        fileActualUpload.push(file);
                                    }
                                }
                            });

                            if (!Utils.isEmptyArray(fileActualUpload)) {
                                isInputFieldRequired = true;
                            } else {
                               return false;
                            }
                        } else {
                            isInputFieldRequired = true;
                        }
                    } else {
                       return false;
                    }
                    break;
                } else if (
                           Utils.isEmpty(fieldValue) ||
                           fieldValue === '' ||
                           (field.type === Constant.FORM_TYPE.FIELD_TAG &&
                               (Utils.isEmptyArray(fieldValue) ||
                                   fieldValue.some(i => i?.value === null)))
                       ) {
                         return false;
                       }
            }
        }

        return isInputFieldRequired;
    }

    return true;
};

/**
 * isInputValueInCustomForm
 * validate is input value in customer form
 * @param {*} field
 * @param {*} fieldValue
 * @returns
 */
export const isInputValueInCustomForm = (field, fieldValue) => {
    if (!fieldValue) {
        return false;
    }

    if (field.type === Constant.FORM_TYPE.FIELD_RICHTEXT) {
        let textInput = getRichTextFieldContent(fieldValue);
        if (textInput) {
            return true;
        }
    }

    fieldValue = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue;

    if (
        (fieldValue &&
            [
                Constant.FORM_TYPE.FIELD_TEXT,
                Constant.FORM_TYPE.FIELD_INT,
                Constant.FORM_TYPE.FIELD_URL,
                Constant.FORM_TYPE.FIELD_IFRAME,
                Constant.FORM_TYPE.FIELD_DATE,
                Constant.FORM_TYPE.FIELD_TIME,
                Constant.FORM_TYPE.FIELD_DATE_TIME
            ].includes(field.type)) ||
        (!Utils.isEmptyArray(fieldValue) && [Constant.FORM_TYPE.FIELD_TAG].includes(field.type))
    ) {
        return true;
    }

    return false;
};

export const getPanelType = (panelList, panelId) => {
    let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelList);
    if (currentPanelIndex === -1) return '';

    let currentPanel = panelList[currentPanelIndex];
    return currentPanel.type;
};

export const updateUsingTicketOfFormListState = (currentCorporationFormList, setCurrentCorporationFormList, formSelectedId, newTicket) => {
    let formListClone = cloneDeep(currentCorporationFormList);
    let formIndex = Utils.findIndexInArrayById(formSelectedId, formListClone);
    if(formIndex !== -1) {
        let formDetail = formListClone[formIndex];
        let usingTickets = Utils.convertJSONDataToObject(formDetail.usingTickets);

        if (!Utils.isEmptyObject(usingTickets)) {
            if (usingTickets[newTicket.affiliationProject]) {
                usingTickets[newTicket.affiliationProject].push(newTicket.id);
            } else {
                usingTickets[newTicket.affiliationProject] = [newTicket.id];
            }
        } else {
            usingTickets = {};
            usingTickets[newTicket.affiliationProject] = [newTicket.id];
        }

        formListClone[formIndex].usingTickets = JSON.stringify(usingTickets);
    }
    setCurrentCorporationFormList(formListClone);
}